// Servicio de autenticación
import { apiClient } from './api';
import { API_ENDPOINTS } from '../config';

export const authService = {
  /**
   * Registrar un nuevo usuario
   * @param {Object} userData - Datos del usuario: { name, email, phone, password }
   * @returns {Promise<Object>} Usuario y token
   */
  async register(userData) {
    try {
      console.log('🔵 Iniciando registro con:', { ...userData, password: '***' });
      console.log('🔵 Endpoint:', API_ENDPOINTS.REGISTER);
      
      const response = await apiClient.post(API_ENDPOINTS.REGISTER, userData);
      
      console.log('🟢 Respuesta del registro:', response);
      
      if (response.success && response.data && response.data.token) {
        // Guardar token en localStorage
        localStorage.setItem('auth_token', response.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.user));
        localStorage.setItem('isLoggedIn', 'true');
        console.log('✅ Token guardado en localStorage');
      } else {
        console.warn('⚠️ Respuesta sin token:', response);
      }
      
      return response;
    } catch (error) {
      console.error('❌ Error en registro:', error);
      console.error('❌ Error details:', {
        message: error.message,
        status: error.status,
        errors: error.errors
      });
      throw error;
    }
  },

  /**
   * Iniciar sesión
   * @param {Object} credentials - Credenciales: { email, password }
   * @returns {Promise<Object>} Usuario y token
   */
  async login(credentials) {
    try {
      const response = await apiClient.post(API_ENDPOINTS.LOGIN || `${API_ENDPOINTS.USER}/login`, credentials);
      
      if (response.success && response.data.token) {
        // Guardar token en localStorage
        localStorage.setItem('auth_token', response.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.user));
        localStorage.setItem('isLoggedIn', 'true');
      }
      
      return response;
    } catch (error) {
      console.error('Error en login:', error);
      throw error;
    }
  },

  /**
   * Cerrar sesión
   */
  logout() {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('user');
    localStorage.removeItem('isLoggedIn');
    
    // Limpiar cualquier otro dato relacionado con la sesión
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && (key.startsWith('auth_') || key.startsWith('user_') || key.startsWith('session_'))) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach(key => localStorage.removeItem(key));
    
    // También limpiar sessionStorage
    sessionStorage.clear();
  },

  /**
   * Obtener usuario actual desde localStorage
   * @returns {Object|null} Usuario o null
   */
  getCurrentUser() {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },

  /**
   * Obtener usuario actual desde el backend
   * @returns {Promise<Object|null>} Usuario o null
   */
  async getCurrentUserFromBackend() {
    try {
      const response = await apiClient.get(API_ENDPOINTS.USER);
      
      if (response.success && response.data) {
        // Actualizar el usuario en localStorage con los datos del backend
        localStorage.setItem('user', JSON.stringify(response.data));
        return response.data;
      }
      
      return null;
    } catch (error) {
      console.error('Error obteniendo usuario del backend:', error);
      // Si el error es 401, el token es inválido
      if (error.status === 401) {
        this.logout();
      }
      return null;
    }
  },

  /**
   * Verificar si el usuario está autenticado
   * @returns {boolean}
   */
  isAuthenticated() {
    return !!localStorage.getItem('auth_token') && localStorage.getItem('isLoggedIn') === 'true';
  },

  /**
   * Obtener token de autenticación
   * @returns {string|null}
   */
  getToken() {
    return localStorage.getItem('auth_token');
  },

  /**
   * Solicitar recuperación de contraseña por username
   * @param {Object} data - Datos: { username }
   * @returns {Promise<Object>} Respuesta del servidor
   */
  async forgotPassword(data) {
    try {
      const response = await apiClient.post(API_ENDPOINTS.FORGOT_PASSWORD, data);
      return response;
    } catch (error) {
      console.error('Error en forgotPassword:', error);
      throw error;
    }
  },

  /**
   * Restablecer contraseña con token
   * @param {Object} data - Datos: { username, token, password, password_confirmation }
   * @returns {Promise<Object>} Respuesta del servidor
   */
  async resetPassword(data) {
    try {
      const response = await apiClient.post(API_ENDPOINTS.RESET_PASSWORD, data);
      return response;
    } catch (error) {
      console.error('Error en resetPassword:', error);
      throw error;
    }
  },
};

